import z from 'zod'

export const selectMembersListTabSchema = z.object({
  tab: z.string(),
})
